import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import {persistor, store} from './redux/store';
import './index.css';
import {BrowserRouter} from "react-router-dom";

// Pages
import Liquid from "./Liquid";
import {PersistGate} from "redux-persist/integration/react";

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <BrowserRouter>
                <Liquid/>
            </BrowserRouter>
        </PersistGate>
    </Provider>
  </React.StrictMode>
);